module.exports = __webpack_public_path__ + "img/model_42_ug.e297b458.jpg";